
import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoPatientTemplateItemCalculationModalStore } from '../stores';
import { NikoPatientTemplateItemCalculationModalTemplate } from 'themes/application/niko-patient/components';

@setCurrentView((rootStore, componentProps) => new NikoPatientTemplateItemCalculationModalStore(rootStore, componentProps), 'nikoPatientTemplateItemCalculationModalStore')
@observer
class NikoPatientTemplateItemCalculationModal extends React.Component {
    render() {
        return <NikoPatientTemplateItemCalculationModalTemplate {...this.props} />
    }
}

export default NikoPatientTemplateItemCalculationModal;
